import { isAxiosError } from 'axios'

import { Listing } from '@app/models'
import { listingsApiV2 } from '@app/services'

import { getUserCurrency } from '@app/utils'
import { DEFAULT_LANGUAGE } from '@app/utils/regional'

import { FetchListingsResponse } from './types'
import { QueryMode } from '../types'

export const fetchListings = async (
  listingsIds: number[],
  lang: string,
  mode: QueryMode = 'Puzzle',
  isFallback = false
): Promise<Listing[]> => {
  if (listingsIds.length === 0) {
    const data: FetchListingsResponse = { listings: [], total: 0 }

    return data.listings
  }

  try {
    const baseLang = lang.split('-')[0]
    const currencyId = getUserCurrency()

    const requestBody = { listings: listingsIds }

    const { data } = await listingsApiV2.post<FetchListingsResponse>(
      'listings/ids',
      requestBody,
      {
        params: {
          'query.mode': mode,
          'query.currencyId': currencyId,
        },
        headers: {
          'Accept-Language': baseLang,
        },
      }
    )

    return data.listings
  } catch (error) {
    if (isAxiosError(error) && error.response?.status === 400 && !isFallback) {
      return fetchListings(listingsIds, DEFAULT_LANGUAGE, mode, true)
    }
    if (isFallback) {
      console.error('Failed to fetch countries for fallback language', error)
    }
    return []
  }
}
